'use strict';
define([], function () {
    function SEOCheckerGeoController($scope) {
        var vm = $scope;
        var ringCircumference = 2 * Math.PI * 34;
        var gaugeCircumference = Math.PI * 80;

        vm.$watch('aeo', function (aeo) {
            if (!aeo) {
                return;
            }

            var summary = aeo.summary || {};
            vm.geoScore = Math.round(Number(summary.score) || 0);
            vm.geoLevel = summary.level;
            vm.geoLevelName = summary.levelName;
            vm.geoScoreColor = scoreColor(vm.geoScore);
            vm.geoGaugeDash = (vm.geoScore / 100) * gaugeCircumference;
            vm.geoExams = aeo.exams || {};
            vm.geoCategories = (summary.categories || []).map(function (category) {
                var passed = Number(category.passed) || 0;
                var eligible = Number(category.eligible) || 0;
                var pct = eligible ? (passed / eligible) * 100 : 0;
                return {
                    id: category.id,
                    label: category.label,
                    passed: passed,
                    eligible: eligible,
                    notChecked: !!category.notChecked || !eligible,
                    ringDash: eligible ? (passed / eligible) * ringCircumference : 0,
                    ringColor: scoreColor(pct)
                };
            });
        });

        function scoreColor(value) {
            if (value >= 75) return 'var(--sto-color-success)';
            if (value >= 50) return 'var(--sto-color-warning)';
            return 'var(--sto-color-critical)';
        }
    }

    SEOCheckerGeoController.$inject = ['$scope'];
    return SEOCheckerGeoController;
});
